import get from "lodash/get";
import find from "lodash/find";
import uniqBy from "lodash/uniqBy";
import groupBy from "lodash/groupBy";
import defaults from "lodash/defaults";
import CalendarDuplicateWorkoutModal from "../../../parts/modals/calendar-duplicate-workout";
import CalendarMoveWorkoutModal from "../../../parts/modals/calendar-move-workout";
import CalendarShiftWorkoutModal from "../../../parts/modals/calendar-shift-workout";
import DuplicateWeekModal from "../../../parts/modals/duplicate-week";
import ProgressionModal from "../../../parts/modals/progression";

import CalendarAddExerciseModal from "../../../parts/modals/calendar-add-exercise";
import VideoModal from "../../../parts/modals/video";
import SwapExerciseModal from "../../../parts/modals/swap-exercise";

import { DATE_FORMATS } from "../../../constants";

const { DATE_YEAR_FORMAT, DATE_DAY_FORMAT, DATE_MONTH_DAY_WITHOUT_ZERO } =
  DATE_FORMATS;
import moment from "moment";
import CalendarMonth from "./CalendarMonth";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const CalendarMonthController = async ({ req, res, locals, flash, load }) => {
  const { query = {} } = req;
  defaults(query, {
    month: moment().format(DATE_YEAR_FORMAT),
    view: "month",
    editCalendar: false,
    metrics: false,
    exercise: "all",
    day: moment().format(DATE_DAY_FORMAT),
    error: false,
  });

  if (query.error) {
    flash("error", query.error);
    return res.refreshWith({ error: false });
  }

  const modal = get(query, "modal", {});

  locals.activeMonth = moment.utc(query.month, DATE_YEAR_FORMAT);

  const startingCalendarDay = locals.activeUser.startingCalendarDay || 0;
  const date = locals.activeMonth
    .clone()
    .startOf("week")
    .weekday(startingCalendarDay);
  const dayNumber = parseInt(date.format("D"));

  if (dayNumber > 1 && dayNumber < 7) date.add(-1, "weeks");

  locals.startOfFirstWeek = date;

  const endDate = locals.activeMonth
    .clone()
    .endOf("month")
    .endOf("week")
    .add(startingCalendarDay, "days");

  locals.endOfLastWeek = endDate;

  // Cache remove for MSB-411

  locals.activeExercises = await load("activeExercises", {
    start: locals.startOfFirstWeek,
    end: locals.endOfLastWeek,
    proxyAthlete: query.athlete,
    reqSource: "calendar",
  });
  locals.scheduledSessions = groupBy(locals.activeExercises, (e) =>
    moment
      .utc((e.utcDate && e.utcDate.toString()) || e.date)
      .format(DATE_DAY_FORMAT)
  );
  locals.calendarMetrics = query.metrics
    ? await load("calendarMetrics", {
        athlete: query.athlete,
        type: query.metrics,
        exercise: query.exercise,
      })
    : null;

  const cycles = uniqBy(
    locals.activeExercises.filter((e) => e.cycle),
    "cycle.id"
  ).map((exercise) => exercise.cycle.id);
  await load("cycles", cycles, query.athlete);

  const duplicateDate = query.day ? moment(query.day) : date;

  let weeks = [];
  let startDays = [];
  let checkDuplicate = [];

  for (let i = 1; i <= 6; i++) {
    const start = duplicateDate.clone().add(i, "weeks");

    const end = duplicateDate.clone().add(i, "weeks").add(6, "days");

    const haveExercises = locals.activeExercises.some(
      ({ date }) =>
        start.isSameOrBefore(moment(date)) && end.isSameOrAfter(moment(date))
    );

    checkDuplicate.push(haveExercises);
    startDays.push(start);
    weeks.push(
      `${start.format(DATE_MONTH_DAY_WITHOUT_ZERO)} - ${end.format(
        DATE_MONTH_DAY_WITHOUT_ZERO
      )}`
    );
  }

  const editExercise = query.editMode
    ? find(locals.activeExercises, { _id: query.exercise })
    : {};

  const isAllowToViewAllOrganizationsAthletes =
    locals.organizationRoleName &&
    (locals.organizationRoleName === "Owner" ||
      locals.organizationRoleName === "Admin");
  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.allAthletesFromOrganization
  ) {
    await load("allAthletesFromOrganization");
  }

  locals.modal = {
    "calendar-add-exercise": (
      <CalendarAddExerciseModal
        editExercise={editExercise}
        reqSource="calendar"
      />
    ),
    "calendar-duplicate-workout": <CalendarDuplicateWorkoutModal />,
    "calendar-move-workout": <CalendarMoveWorkoutModal />,
    "calendar-shift-workout": <CalendarShiftWorkoutModal />,
    "calendar-duplicate-week": (
      <DuplicateWeekModal
        weeks={startDays}
        duplicateCheck={checkDuplicate}
        weeksOrder={weeks}
        from={query.day}
        calendarMode
        proxyAthlete={query.athlete}
      />
    ),
    progression: (
      <ProgressionModal
        from={query.day}
        calendarMode
        proxyAthlete={query.athlete}
      />
    ),
    video: <VideoModal />,
    "swap-exercise": <SwapExerciseModal exercise={editExercise} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  if (
    modal.type === "calendar-move-workout" ||
    modal.type === "calendar-duplicate-workout" ||
    modal.type === "calendar-shift-workout"
  ) {
    await load("activeExercises", {
      start: moment(0),
      end: moment("Dec 31 2049"),
      proxyAthlete: query.athlete,
      reqSource: "calendar",
    });
  }

  res.body = (
    <CalendarMonth
      athleteProp={query.athlete}
      showBack={query.showBack || false}
    />
  );
};

export default CalendarMonthController;
